import { render, staticRenderFns } from "./MyPoints.vue?vue&type=template&id=03c095b5&scoped=true&"
import script from "./MyPoints.vue?vue&type=script&lang=js&"
export * from "./MyPoints.vue?vue&type=script&lang=js&"
import style0 from "./MyPoints.vue?vue&type=style&index=0&id=03c095b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c095b5",
  null
  
)

export default component.exports